import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

const ZONES = [
  { id: "prices", label: "Prices" },
  { id: "news", label: "Latest" },
  { id: "tools", label: "Tools" },
  { id: "analytics", label: "Analytics" },
];


/**
 * Sticky in-page zone navigation. Sits directly under the main site nav and
 * only appears once the visitor has scrolled past the top strip.
 */
export function HomeSubNav() {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState<string>("prices");

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 240);
      let current = ZONES[0].id;
      for (const z of ZONES) {
        const el = document.getElementById(z.id);
        if (el && el.getBoundingClientRect().top <= 140) current = z.id;
      }
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={cn(
        "sticky top-11 md:top-12 z-40 border-b border-border bg-background/95 backdrop-blur transition-all duration-200",
        visible ? "opacity-100 translate-y-0" : "pointer-events-none opacity-0 -translate-y-2",
      )}
      aria-hidden={!visible}
    >
      <nav aria-label="Homepage sections" className="container mx-auto px-4">
        <ul className="flex items-center gap-1 overflow-x-auto py-1.5">
          {ZONES.map((z) => (
            <li key={z.id}>
              <a
                href={`#${z.id}`}
                className={cn(
                  "block px-3 py-1 rounded-full text-xs font-semibold uppercase tracking-wide whitespace-nowrap transition-colors",
                  active === z.id
                    ? "bg-primary text-primary-foreground"
                    : "text-muted-foreground hover:text-foreground hover:bg-muted",
                )}
              >
                {z.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
